import { useEffect } from 'react';

interface UseInstagramPublicationsGridEffectsProps {
  isEnabled: boolean;
  isLoadedForIntegration: boolean;
  loadFirstPage: (isManualRefresh: boolean) => Promise<void>;
}

export const useInstagramPublicationsGridEffects = ({
  isEnabled,
  isLoadedForIntegration,
  loadFirstPage,
}: UseInstagramPublicationsGridEffectsProps) => {
  // Список грузится при первом открытии вкладки «Выбранные» и заново —
  // при смене интеграции. Повторное переключение вкладок его не перезапрашивает.
  useEffect(() => {
    if (isEnabled && !isLoadedForIntegration) {
      loadFirstPage(false);
    }
  }, [isEnabled, isLoadedForIntegration, loadFirstPage]);
};
